import axios from 'axios'
import { USER_PROFILE } from '@/constants/path'

const state = () => ({
  data: null,
  isError: false,
  isLoading: false,
})

// getters
const getters = {}

// actions
const actions = {
  async getUserProfile({ commit, dispatch, state }) {
    commit('SET_LOADING', true)
    try {
      if (!state.data) {
        const res = await axios.get(USER_PROFILE)
        commit('SET_DATA', res?.data?.data)
      }
      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_DATA', null)
      commit('SET_LOADING', false)
      dispatch('auth/logout', null, {
        root: true,
      })

      throw error
    }
  },
  async setData({ commit }, payload) {
    try {
      commit('SET_DATA', payload)
    } catch (error) {
      commit('SET_DATA', null)

      throw error
    }
  },
}

// mutations
const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload
  },
  SET_DATA(state, payload) {
    state.data = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
